export default __webpack_public_path__ + "static/media/iconUserEmptyFill.a76027d7.svg";